import Notification, {NotificationType} from 'components/Notification';
import {FC, HTMLAttributes} from 'react';
import {useBackend} from 'state/backend';
import {twMerge} from 'tailwind-merge';
import {Backend, LevelTags} from 'types/api';

export const TYPES: Record<LevelTags, NotificationType> = {
    error: 'danger',
    info: 'system',
    success: 'success',
    warning: 'alert',
};

const DjangoMessages: FC<HTMLAttributes<HTMLDivElement>> = ({
    className,
    ...props
}) => {
    const {messages} = useBackend<Backend<unknown>>();

    if (!messages || messages.length === 0) {
        return null;
    }

    return (
        <div className={twMerge('flex flex-col gap-2', className)} {...props}>
            {messages.map(({id, level_tag, message}) => (
                <Notification key={id} type={TYPES[level_tag]}>
                    {message}
                </Notification>
            ))}
        </div>
    );
};

export default DjangoMessages;
